import React from 'react';
import { withRouter } from 'inferno-router';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  ScrollView,
} from './components/base_components';
import { BusyComponent, BusyOverlay } from './components/busy_component';
import ProgressSpinner from './components/progress_spinner';
import TextButton from './components/buttons/text_button';

import OrgStore from './stores/org_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  userListScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '3em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  headerText: {
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  list: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  add: {
    marginTop: '1em',
  },
  text: {
    marginTop: '1em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  itemLine: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
    flexDirection: 'row',
  },
  value: {
    width: '20em',
  },
  itemButton: {
    height: '2em',
  },
  button: {
    marginBottom: '2em',
    width: '10em',
    height: '2em',
  },
  input: {
    marginTop: '0.5em',
    width: '25em',
    height: '3em',
    paddingLeft: '1em',
    color: 'black',
    backgroundColor: '#ccc',
    borderRadius: '0.5em',
  },
  addButton: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
    height: '2.5em',
  },
});

type Props = {
  match: any;
};
type State = {
  is_admin: boolean;
  org_list: [any];
  org_name: string;
  filestore_username: string;
  filestore_password: string;
  filestore_tenant: string;
  filestore_container: string;
};

class OrgListScreen extends BusyComponent<Props, State> {
  state = {
    is_admin: UserStore.getUser().is_super_admin,
    org_list: UserStore.getUser().org_list,
    org_name: '',
    filestore_username: '',
    filestore_password: '',
    filestore_tenant: '',
    filestore_container: '',
  };

  _onOrgPress = (org) => {
    const { history } = this.props;
    const { org_id } = org;
    history.push(`/admin/org/${org_id}`);
  };
  _onAddOrg = () => {
    const {
      org_name,
      filestore_username,
      filestore_password,
      filestore_tenant,
      filestore_container,
    } = this.state;
    if (
      org_name &&
      filestore_username &&
      filestore_password &&
      filestore_tenant &&
      filestore_container &&
      this.setBusy()
    ) {
      const opts = {
        org_name,
        filestore_username,
        filestore_password,
        filestore_tenant,
        filestore_container,
      };
      OrgStore.createOrg(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Add failed!');
        } else {
          const org_list = UserStore.getUser().org_list;
          this.setState({ org_list });
          window.alert('org added');
        }
      });
    }
  };

  render() {
    const {
      is_admin,
      org_list,
      org_name,
      filestore_username,
      filestore_password,
      filestore_tenant,
      filestore_container,
    } = this.state;

    let content = null;
    if (!org_list) {
      content = <ProgressSpinner />;
    } else {
      const orgs = org_list.map((org, i) => (
        <Org key={i} org={org} onPress={this._onOrgPress} />
      ));

      content = (
        <>
          <Text style={styles.text}>Orgs:</Text>
          {orgs}
          <Line />
        </>
      );
    }
    let admin_section = null;
    if (is_admin) {
      admin_section = (
        <>
          <Line />
          <Text style={styles.text}>Add Org:</Text>
          <TextInput
            style={styles.input}
            placeholder='Org Name'
            value={org_name}
            onChangeText={(org_name) => this.setState({ org_name })}
          />
          <TextInput
            style={styles.input}
            placeholder='Filestore Username'
            value={filestore_username}
            onChangeText={(filestore_username) =>
              this.setState({ filestore_username })
            }
          />
          <TextInput
            style={styles.input}
            placeholder='Filestore Password'
            value={filestore_password}
            onChangeText={(filestore_password) =>
              this.setState({ filestore_password })
            }
          />
          <TextInput
            style={styles.input}
            placeholder='Filestore Tenant'
            value={filestore_tenant}
            onChangeText={(filestore_tenant) =>
              this.setState({ filestore_tenant })
            }
          />
          <TextInput
            style={styles.input}
            placeholder='Filestore Container'
            value={filestore_container}
            onChangeText={(filestore_container) =>
              this.setState({ filestore_container })
            }
          />
          <TextButton
            style={styles.addButton}
            text='Add Org'
            onPress={this._onAddOrg}
          />
          <Line />
        </>
      );
    }

    return (
      <View style={styles.userListScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Text style={styles.headerText}>MONP ABT</Text>
          <Line />
          {content}
          {admin_section}
        </ScrollView>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
export default withRouter(OrgListScreen);

function Line() {
  return <View style={styles.line} />;
}

function ItemLine(props) {
  const { value, onPress, buttonText } = props;

  return (
    <View style={styles.itemLine}>
      <Text style={styles.value}>{value}</Text>
      <TextButton
        style={styles.itemButton}
        text={buttonText}
        onPress={onPress}
      />
    </View>
  );
}

function Org(props) {
  const { org, onPress } = props;
  const { org_id, org_name } = org;
  function _onPress() {
    onPress(org);
  }
  return <ItemLine value={org_name} buttonText='edit' onPress={_onPress} />;
}
